import MediaWindow from "../../components/MediaWindow/MediaWindow"

export default function Media() {
  return <MediaWindow />
}
